import { put, takeEvery } from 'redux-saga/effects'
import { GITCARD_LOADING, GET_GITCARD_DATA_SUCCESS, GET_GITCARD_DATA_ERROR } from "../actions/actionGiftCards";
import { apiGiftCards } from 'api';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok) {
        return await response.json();
    }
    else if (response.statusText === 'Unauthorized') {
        throw new Error("Authorization has been denied for this request.");
    }
    else {
        throw new Error("Unable to Get Gift Cards, response: " + response.statusText + " - " + response.status)
    }
}

function* fetchGiftCardsData(action) {
    try {
        const data = yield fetchAsync(apiGiftCards, action.payload.displayAreaNo)
        yield put({ type: GET_GITCARD_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: GET_GITCARD_DATA_ERROR, error: e.message });
    }
}

export const sagaGiftcards = [
    takeEvery(GITCARD_LOADING, fetchGiftCardsData)
];
